import {en} from './en'
import {de} from './de'

const resources = {
    en, 
    de
}

export default resources